import React from 'react';

const BOOKING_URL = process.env.REACT_APP_BOOKING_URL || 'https://agenda.filtrosyaceitesjm.com/login';

const TemplateModern = ({ data, config }) => {
  const activeServices = Array.isArray(data?.services) && data.services.length > 0
    ? config.services.filter(s => data.services.includes(s.id))
    : config.services.slice(0, 6);

  const primary = data.brand_color_primary || '#1e293b';
  const secondary = data.brand_color_secondary || '#7c3aed';

  // Hex con opacidad para fondos suaves

  return (
    <div className="min-h-screen bg-gray-900 text-white font-sans">
      {/* Hero Section */}
      <header
        className="relative py-32 px-6 overflow-hidden flex flex-col items-center justify-center text-center"
        style={{
          backgroundImage: `url(${data.hero_image_url || config.images[0].url})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 z-0" style={{ backgroundColor: primary, opacity: 0.82 }}></div>
        <div className="relative z-10 max-w-4xl mx-auto">
          {/* Social Proof Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-md mb-6 shadow-xl">
            <div className="flex gap-1 text-yellow-400 text-sm">
              <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
            </div>
            <span className="text-white/80 text-xs font-bold uppercase tracking-widest border-l border-white/20 pl-2 ml-1">Top Rated</span>
          </div>

          <h1
            className="text-5xl md:text-7xl font-black mb-6 tracking-tighter"
            style={{
              backgroundImage: `linear-gradient(to right, ${secondary}, #ffffff)`,
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent'
            }}
          >
            {data.name || config.defaultTitle}
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-2xl mx-auto">
            {config.defaultDescription}
          </p>
          <button
            className="group relative text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 hover:scale-105 shadow-xl hover:shadow-2xl"
            style={{ backgroundColor: secondary }}
            onClick={() => { window.location.href = `${data.booking_url || BOOKING_URL}?workshopId=${data.id}&niche=${data.niche}`; }}
          >
            <span className="relative z-10 flex items-center justify-center gap-2">
              Agendar Cita Ahora
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5"><path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" /></svg>
            </span>
            <div className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ boxShadow: `0 0 30px ${secondary}` }}></div>
          </button>
        </div>
      </header>

      {/* Services Section */}
      <section className="py-20 px-6 relative overflow-hidden" style={{ backgroundColor: '#050810' }}>
        {/* Mesh background */}
        <div className="absolute inset-0 opacity-30" style={{
          backgroundImage: `radial-gradient(ellipse at 20% 50%, ${secondary}18 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, ${primary}30 0%, transparent 50%)`
        }}></div>

        <div className="relative max-w-6xl mx-auto">
          <div className="flex items-center gap-4 mb-12">
            <div className="h-px bg-gray-800 flex-1"></div>
            <h2 className="text-3xl font-bold text-center tracking-wide uppercase text-gray-400">Servicios</h2>
            <div className="h-px bg-gray-800 flex-1"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {activeServices.map((service, index) => (
              <div
                key={index}
                className="relative p-7 rounded-2xl group transition-all duration-300"
                style={{
                  background: 'rgba(255,255,255,0.04)',
                  backdropFilter: 'blur(16px)',
                  WebkitBackdropFilter: 'blur(16px)',
                  border: `1px solid rgba(255,255,255,0.08)`,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.06)',
                }}
              >
                {/* Reflejo de luz superior */}
                <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{ background: 'linear-gradient(135deg, rgba(255,255,255,0.10) 0%, transparent 45%)' }}></div>
                {/* Linea top con color de marca */}
                <div className="absolute top-0 left-6 right-6 h-px rounded-full" style={{ background: `linear-gradient(to right, transparent, ${secondary}80, transparent)` }}></div>

                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-5 text-2xl"
                  style={{
                    background: `linear-gradient(135deg, ${secondary}25, ${secondary}10)`,
                    border: `1px solid ${secondary}30`,
                  }}
                >
                  {service.icon}
                </div>
                <h3 className="text-lg font-bold capitalize mb-2 text-white">{service.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="pt-16 pb-8 px-6" style={{ backgroundColor: '#020408', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-16 mb-12 text-left">
            
            {/* 1. Marca y Descripción */}
            <div className="md:col-span-4 flex flex-col">
              <h3 className="text-white font-black text-2xl mb-4 tracking-tight">{data.name}</h3>
              {data.footer_tagline && (
                <p className="text-sm leading-relaxed mb-6 text-gray-400">
                  {data.footer_tagline}
                </p>
              )}
              <div className="flex flex-wrap gap-2.5 mt-auto">
                {data.whatsapp && (
                  <a href={`https://wa.me/${data.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-3 py-2 rounded-full text-white text-xs font-bold transition-opacity hover:opacity-80"
                    style={{ backgroundColor: '#25D366' }}>
                    <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.122 1.532 5.855L.057 23.885a.75.75 0 0 0 .92.92l6.104-1.464A11.945 11.945 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.696 9.696 0 0 1-4.945-1.355l-.355-.21-3.625.869.883-3.538-.23-.367A9.697 9.697 0 0 1 2.25 12C2.25 6.615 6.615 2.25 12 2.25S21.75 6.615 21.75 12 17.385 21.75 12 21.75z"/></svg>
                    WhatsApp
                  </a>
                )}
                {data.instagram && (
                  <a href={data.instagram} target="_blank" rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-3 py-2 rounded-full text-white text-xs font-bold transition-opacity hover:opacity-80"
                    style={{ background: 'linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' }}>
                    <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/></svg>
                    Instagram
                  </a>
                )}
                {data.facebook && (
                  <a href={data.facebook} target="_blank" rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-3 py-2 rounded-full text-white text-xs font-bold transition-opacity hover:opacity-80"
                    style={{ backgroundColor: '#1877F2' }}>
                    <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
                    Facebook
                  </a>
                )}
              </div>
            </div>

            {/* 2. Info de Contacto */}
            <div className="md:col-span-4 flex flex-col">
              <h4 className="text-white font-bold mb-6 text-sm uppercase tracking-wider">Contacto</h4>
              <ul className="space-y-4 text-sm text-gray-400">
                {data.phone && (
                  <li className="flex items-start gap-3">
                    <span className="text-lg leading-none">📞</span>
                    <span className="mt-0.5">{data.phone}</span>
                  </li>
                )}
                {data.address && (
                  <li className="flex items-start gap-3">
                    <span className="text-lg leading-none">📍</span>
                    <span className="mt-0.5">{data.address}{data.city ? `, ${data.city}` : ''}</span>
                  </li>
                )}
              </ul>
            </div>

            {/* 3. Mapa interactivo */}
            {data.address && (
              <div className="md:col-span-4 flex flex-col">
                <h4 className="text-white font-bold mb-6 text-sm uppercase tracking-wider">Ubicación</h4>
                <div className="w-full h-48 rounded-xl overflow-hidden shadow-2xl relative group" style={{ border: '1px solid rgba(255,255,255,0.1)' }}>
                  <iframe
                    title="map"
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    style={{ border: 0 }}
                    src={`https://www.google.com/maps?q=${encodeURIComponent(`${data.address}, ${data.city || ''}`)}&output=embed`}
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            )}
          </div>
          
          <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs border-t border-white/5 text-gray-600">
            <p>© {new Date().getFullYear()} {data.name}. Todos los derechos reservados.</p>
            <div className="flex gap-6 font-medium">
              <a href="#" className="hover:text-white transition-colors duration-300">Privacidad</a>
              <a href="#" className="hover:text-white transition-colors duration-300">Términos</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TemplateModern;
